import axios from "axios";
import Cookies from "js-cookie";
if (process.env.NODE_ENV == "development") {
  // axios.defaults.baseURL = "https://app.gztv.com:7443";
  // axios.defaults.baseURL = "http://localhost:8888";
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;
}

if (process.env.NODE_ENV == "production") {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;
  // axios.defaults.baseURL = "https://app.gztv.com:7443";
  //axios.defaults.baseURL = "https://gscb.kuaihd.com:7443";
}

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? "https://gscb.kuaihd.com:7443"
      : "https://app.gztv.com:7443",
  timeout: 10000,
});

// 设置超出时间
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 获取request请求头信息
    console.log("获取request请求头信息", config);

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    console.log("拦截", response);
    const cookies = response.headers["set-cookie"];
    console.log(cookies);
    return response.data;
  },
  (error) => {
    // 处理响应错误
    return Promise.reject(error);
  }
);

// 请求拦截
// axios.interceptors.request.use(config => {
//   config.headers = {
//     Authorization: ""
//   };
//   return config;
// });

// 封装get方法  并抛出
export function get(url, params) {
  const obj = Object.assign({}, params);
  obj.ticket = Cookies.get("ticket-id");

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: obj,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 封装post方法  并抛出
export function post(url, params) {
  const obj = Object.assign({}, params);
  obj.ticket = Cookies.get("ticket-id");
  obj.cookieId = obj.ticket;
  return new Promise((resolve, reject) => {
    axios
      .post(url, obj)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

// 封装post方法  并抛出
export function postForm(url, params) {
  const obj = Object.assign({}, params);
  obj.ticket = Cookies.get("ticket-id");
  obj.cookieId = obj.ticket;
  return new Promise((resolve, reject) => {
    axios
      .post(url, obj, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export { instance as request };
